import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

export interface IAttendancePolicy {
  id: string
  name: string
  description?: string
  enabled: boolean
  default: boolean
  employees: string[]
  active_employees: string[]
  company_id: string
}

class AttendancePolicy extends Model<IAttendancePolicy> {
  constructor(attr: IAttendancePolicy) {
    super(attr)

    makeObservable(this, {
      isDefault: computed,
    })
  }

  static urlRoot() {
    return '/api/rest/attendance/employees_policy'
  }

  get isDefault(): boolean {
    return this.attributes.default
  }
}

export default AttendancePolicy
